// Spremanje velikog dokumenta u komadima, s napretkom.
//
// Prijenos pocetnog stanja zna imati nekoliko tisuca redaka. Dok je sve islo u
// jednom zahtjevu, korisnik je gledao prazan ekran bez ikakve povratne
// informacije i nije znao radi li program ili je stao.
//
// VAZNO: "/mainledgerdetail/saveitems" brise retke dokumenta kojih u zahtjevu
// nema. Zato PRVI komad ide bez zastavice - on zamjenjuje dokument - a svaki
// sljedeci sa "?nastavak=true", koji samo dodaje. Da se taj redoslijed obrne ili
// da se zastavica izostavi, svaki bi komad obrisao prethodni i na kraju bi u
// dokumentu ostao samo zadnji.

const VELICINA = 1000

/**
 * Dijeli popis na komade zadane velicine.
 */
export const podijeli = (stavke, velicina) => {
  const n = parseInt(velicina) > 0 ? parseInt(velicina) : VELICINA
  const popis = stavke || []
  const komadi = []
  for (let i = 0; i < popis.length; i += n) { komadi.push(popis.slice(i, i + n)) }
  return komadi
}

/**
 * Salje popis u komadima i javlja napredak.
 *
 * @param {Array}    stavke
 * @param {Function} posalji   async (komad, nastavak) => odgovor
 * @param {Function} napredak  ({poslano, ukupno, komad, komada}) => void
 * @param {number}   velicina  stavaka po komadu
 * @returns {{ukupno:number, komada:number, dodano:number}}
 *
 * Prvi komad ide s nastavak=false, ostali s nastavak=true. Ako neki komad
 * padne, greska se propagira - dokument tada ostaje nepotpun, pa se poruka o
 * gresci mora pokazati, a ne progutati.
 */
export const spremiUKomadima = async (stavke, posalji, napredak, velicina) => {
  const komadi = podijeli(stavke, velicina)
  const ukupno = (stavke || []).length
  let poslano = 0
  let dodano = 0

  for (let i = 0; i < komadi.length; i += 1) {
    const odgovor = await posalji(komadi[i], i > 0)
    poslano += komadi[i].length
    const d = odgovor && odgovor.data ? odgovor.data : odgovor
    if (d && typeof d.dodano === 'number') { dodano += d.dodano }
    if (typeof napredak === 'function') {
      napredak({poslano: poslano, ukupno: ukupno, komad: i + 1, komada: komadi.length})
    }
  }

  return {ukupno: ukupno, komada: komadi.length, dodano: dodano}
}

export default spremiUKomadima
